export default __webpack_public_path__ + "static/media/BG_Page_2022.2f603ad4.png";